import Button from '@material-ui/core/Button';
import { useBottomDrawer } from '../../../hooks/useBottomDrawer';

export default function CreateCancel({ onCreate, forceCancel, onCancel, root, createDisable, content, cancelText, sticky, hideCancel=false }) {
    const bottomDrawer = useBottomDrawer()

    return (
        <>
            {
                (!bottomDrawer || forceCancel) && !hideCancel &&
                <Button onClick={onCancel} variant="contained" id={(`${root || "form"}_${cancelText ? cancelText : 'Cancel'}`).toLowerCase()} style={{ marginLeft: 10, textTransform: 'capitalize' }}>
                    {cancelText ? cancelText : 'Cancel'}
                </Button>
            }
            <Button 
                onClick={onCreate} 
                disabled={createDisable} 
                id={(`${root || "form"}_${content !== undefined ? content : 'Create'}`).toLowerCase()} 
                color="primary" 
                variant="contained" 
                style={{ marginLeft: 10, textTransform: 'capitalize' }}
                className={sticky && 'update_btn'}
            >
                {content !== undefined ? content : 'Create'}
            </Button>
        </>
    )
}